/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const ArrowForwardDouble = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 15 10" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M1.34.21A.78.78 0 0 0 .2.29.89.89 0 0 0 .28 1.5L4 4.87.26 8.52a.87.87 0 0 0 0 1.2.76.76 0 0 0 .55.28.8.8 0 0 0 .55-.23l4.38-4.29A.9.9 0 0 0 6 4.84a.92.92 0 0 0-.28-.63zm13.38 4l-4.38-4A.78.78 0 0 0 9.2.29a.89.89 0 0 0 .08 1.21L13 4.87 9.26 8.52a.87.87 0 0 0 0 1.2.76.76 0 0 0 .59.28.8.8 0 0 0 .55-.23l4.38-4.29a.9.9 0 0 0 .22-.64.92.92 0 0 0-.28-.63z" />
      </g>
    </svg>
  </span>
);

ArrowForwardDouble.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

ArrowForwardDouble.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default ArrowForwardDouble;
